module.exports = __webpack_public_path__ + "static/media/sura-small-street-selected.5c6e261c.svg";